import { CallToActionSplit } from "../../../../modules/content/components/CallToActionSplit/CallToActionSplit";
import { CallToActionStacked } from "../../../../modules/content/components/CallToActionStacked/CallToActionStacked";
import { WohaSection } from "../../../../modules/content/components/WohaSection/WohaSection";
import type { ICallToActionBlockProps } from "./CallToActionBlock.props";
export const CallToActionBlock = (props: ICallToActionBlockProps) => {
  const { anchorId, buttons, description, eyebrow, heading, image, parentClass, spacing, variant } =
    props;
  if (!eyebrow && !heading && !description && !buttons?.length && !image) return null;
  return (
    <WohaSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="overflow-hidden rounded-2xl bg-midnight-ink p-7 [&_a]:border-white/30 [&_a]:bg-white [&_a]:text-charcoal [&_a:hover]:bg-paper-mist md:p-12 lg:p-16">
        {variant === "split" ? (
          <CallToActionSplit {...props} />
        ) : (
          <CallToActionStacked {...props} />
        )}
      </div>
    </WohaSection>
  );
};
CallToActionBlock.displayName = "Block::CallToActionBlock";
